export const masterSettings = {
  layout: {
    config: {
      toolbar: {
        display: true,
      },
    },
  },
};
